import BaseReducer from "./BaseReducer";

class QrCodeReducer extends BaseReducer {
  domain = "Organisation";
  type = "QrCode";

  initialState = {
    open: false,
    qrValue: { siteCode: "", location: "" },
    locations: [
      { value: "Within Venue", text: "Within Venue" },
      { value: "Outside Venue", text: "Outside Venue" },
    ],
  };
}

const reducer = new QrCodeReducer();

export default reducer;
